// import Footer from './Footer';
import Header from './Header';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import i18n from '@/lib/i18n/i18n';
import { useEffect } from 'react';
import { ImpersonationBanner } from '@/components/auth/ImpersonationBanner';

const DefaultLayout = () => {
    const { pathname } = useLocation();

    // Keep i18n in sync with URL lang prefix so language actually switches when dir/URL change
    useEffect(() => {
        const m = pathname.match(/^\/(ar|en)(?=\/|$)/);
        if (m && m[1]) {
            const urlLang = m[1] as 'ar' | 'en';
            const current = i18n.language?.split('-')[0];
            if (current !== urlLang) {
                i18n.changeLanguage(urlLang).catch((err) => {
                    console.error('Error syncing language from URL:', err);
                });
            }
        }
    }, [pathname]);

    return (
        <main className="md:grid md:grid-cols-[auto_1fr] min-h-screen font-cairo">
            <Sidebar />
            <div className="w-full flex flex-col min-h-screen relative">
                <ImpersonationBanner />
                <Header />
                <div className="flex-grow m-auto px-5 lg:px-6 custom:px-0 w-full custom:w-[1104px]">
                    <Outlet />
                </div>
                {/* <Footer /> */}
            </div>
        </main>
    );
};

export default DefaultLayout;
